function Settings() {
  let settings = [
    {
      name: "settings",
      icon: "KYC Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "settings",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/settings",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };
  const configuration = () => {
    const profileArr = [
      {
        path: "/index/configration",
        name: "Configuration",
        icon: "Kyc Configuration",
        logoName: "kyc configration1",
        flag: "CONFIGURATION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const moduleAllocation = () => {
    const mybanksArr = [
      {
        path: "/index/moduleAllocation",
        name: "Module Allocation",
        icon: "KYC Report",
        logoName: "kyc report",
        flag: "MODULE ALLOCATION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const walletOwnerBank = () => {
    const mycardsArr = [
      {
        path: "/index/wallet-owner-bank",
        name: "Wallet Owner Bank",
        icon: "KYB Report",
        logoName: "MyBank",
        flag: "WALLET OWNER BANKS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const BankMaster = () => {
    const mybanksArr = [
      {
        path: "/index/PartnerBankMaster",
        name: "Bank master",
        icon: "MyBank",
        logoName: "MyBank",
        flag: "WALLET OWNER BANKS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const activityTracker = () => {
    const activityTrackerArr = [
      {
        path: "/index/ActivityTracker",
        name: "Activity Tracker",
        icon: "CREATE PROOF TYPE",
        logoName: "CREATE PROOF TYPE",
        flag: "IP WHITELIST",
      },
    ];
    return activityTrackerArr;
  };

  const IP_Whitelist = () => {
    const ipwhitelistArr = [
      {
        path: "/index/ipWhitelisting",
        name: "IP Whitelisting",
        icon: "CREATE PROOF TYPE",
        logoName: "CREATE PROOF TYPE",
        flag: "IP WHITELIST",
      },
    ];
    return ipwhitelistArr;

  };
  


  let a = dashboard();
  let b = configuration();
  let c = moduleAllocation();
  let d = walletOwnerBank();
  let e = BankMaster();
  let f = activityTracker();
  let g = IP_Whitelist();
  settings[0].items = [...a, ...b, ...c, ...d, ...e, ...f, ...g];

  return settings;
}

export default Settings;
